import * as tslib_1 from "tslib";
import React from 'react';
import { WidthProvider, Responsive } from 'react-grid-layout';
const ReactGridLayout = WidthProvider(Responsive);
export const Grid = (_a) => {
    var { id, children, storageProvider, layouts, isDashboardLocked } = _a, rest = tslib_1.__rest(_a, ["id", "children", "storageProvider", "layouts", "isDashboardLocked"]);
    return (React.createElement(ReactGridLayout, Object.assign({ layouts: layouts, draggableHandle: ".block-drag-handle", isDraggable: !isDashboardLocked, isResizable: !isDashboardLocked }, rest), children));
};
//# sourceMappingURL=Grid.js.map